export * from './iframe/use-cases';
export * from './iframe/router';
export * from './parent/use-cases';
export * from './config/index';
import messagesParent from './iframe/messagesParent.json';
import messageChild from './parent/messagesChild.json';
export const messagesForParent = messagesParent;
export const messagesForChild = messageChild;
export default {
    NOTHING: 'TO SEE HERE',
};
//# sourceMappingURL=index.js.map